import { CalendarIcon } from '@twistopayments/design-system/icons/inline'
import { hiddenDown } from '@twistopayments/design-system/styles'

import type { BlogPostCustom } from '@twisto/api-cms'
import { getMaskFormattedDate } from '@twisto/utils'

import { AccessibleDiv, StrapiMedia } from '../../atoms'

import * as styles from './featured-post.styles'

export const FeaturedPost = ({
  name,
  date,
  image,
  badge,
  path,
  blog_category: category,
}: BlogPostCustom) => (
  <AccessibleDiv
    css={[styles.featured, hiddenDown('smMd')]}
    role="link"
    onActivate={() => window.open(path, '_self')}
  >
    <StrapiMedia
      {...image}
      priority
      css={[styles.image, styles.featuredImage]}
    />

    <div css={styles.featuredDetails}>
      <div css={styles.featuredDate}>
        {badge ||
          (category && (
            <span css={[styles.badge, styles.featuredBadge]}>
              {badge || category.name}
            </span>
          ))}

        <div css={styles.date}>
          <CalendarIcon size="24" />
          {date && getMaskFormattedDate(date, 'DD MMM, YYYY')}
        </div>
      </div>

      <p css={styles.featuredName}>{name}</p>
    </div>
  </AccessibleDiv>
)
